import { Pipe, PipeTransform } from '@angular/core';

/**
 * Returns a string with the concatenated values of a specified property from an array of objects
 */
@Pipe({
  name: 'concatArrayProperty',
  standalone: true
})
export class ConcatArrayPropertiesPipe implements PipeTransform {

  transform(items: any[], property: string): string {
    if (!items || items.length === 0 || !property) {
      return '';
    }

    return items.map(item => item[property]).join(', ');
  }
}